import React from 'react';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';

import palette from '../styles/palette';
import { Text } from '../Base';

const useStyles = makeStyles(({ typography }) => ({
  button: {
    borderRadius: 4,
    border: `1px solid ${palette.typography.black.medium}`,
    marginTop: typography.pxToRem(10),
    padding: `${typography.pxToRem(5)} ${typography.pxToRem(10)}`,
    textTransform: 'none',
    height: typography.pxToRem(30),
    fontSize: typography.pxToRem(14),
    background: palette.typography.white.solid,

    '&:hover': {
      background: palette.typography.white.solid,
    },

    '&:disabled': {
      backgroundColor: palette.typography.white.disabled,
    },
  },
  leftButton: {
    marginRight: typography.pxToRem(5),
  },
  rightButton: {
    marginLeft: 'auto',
  },
  title: {
    color: palette.typography.black.high,
    fontSize: typography.pxToRem(14),
  },
  highlighted: {
    background: palette.yellow,

    '&:hover': {
      background: palette.yellow,
    },
  },
}));

const CustomButton = ({
  title,
  icon,
  onClick,
  disabled,
  rightButton,
  leftButton,
  highlighted,
}) => {
  const classes = useStyles({ rightButton });

  return (
    <Button
      disableRipple
      disableFocusRipple
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      endIcon={icon}
      className={clsx(classes.button, {
        [classes.leftButton]: leftButton,
        [classes.rightButton]: rightButton,
        [classes.highlighted]: highlighted,
      })}
    >
      <Text noWrap className={classes.title}>
        {title}
      </Text>
    </Button>
  );
};

CustomButton.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  rightButton: PropTypes.bool,
  leftButton: PropTypes.bool,
};

export default React.memo(CustomButton);
